var _circle, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableTops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1062_57)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 42.0846L50 29.5454L25 42.0846V46.7868L26.5625 47.5705V63.2445C26.5625 64.543 27.6118 65.5956 28.9062 65.5956H30.4688C31.7632 65.5956 32.8125 64.543 32.8125 63.2445V50.7053L46.875 57.7586V72.6489C46.875 73.9473 47.9243 75 49.2188 75H50.7812C52.0757 75 53.125 73.9473 53.125 72.6489V57.7586L67.1875 50.7053V63.2445C67.1875 64.543 68.2368 65.5956 69.5312 65.5956H71.0938C72.3882 65.5956 73.4375 64.543 73.4375 63.2445V47.5705L75 46.7868V42.0846Z",
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1062_57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.7748 25L25 37.339L49.7748 51L75 37.339L49.7748 25Z",
    fill: "url(#paint1_linear_1062_57)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7748 25L25 37.339L49.7748 51L75 37.339L49.7748 25Z",
    stroke: "url(#paint2_linear_1062_57)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1062_57",
    x: 22.5619,
    y: 22.8212,
    width: 54.884,
    height: 30.3635,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1062_57"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1062_57",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1062_57",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1062_57",
    x1: 30.3506,
    y1: 27.3988,
    x2: 64.7152,
    y2: 61.6173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1062_57",
    x1: 54.1667,
    y1: 29.3333,
    x2: 59.8839,
    y2: 54.9878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableTops);
export default __webpack_public_path__ + "static/media/table-tops.ac0c1d87cfb8077941152cc39ff52c03.svg";
export { ForwardRef as ReactComponent };